/**
 * Pharmacy Setup workspace tab definitions (Lab Catalog twin).
 * Paths preserve existing deep links; tabs compose those routes.
 */

export const PHARMACY_SETUP_TABS = [
  {
    id: "overview",
    path: "/pharmacy/admin/setup",
    label: "Overview",
    match: (p) => p === "/pharmacy/admin/setup" || p === "/setup/pharmacy",
    /** Visible if user can access any Pharmacy Setup surface */
    anyModuleIds: [
      "PHARMACY_SETUP_GENERICS",
      "PHARMACY_ENTERPRISE_MEDICINES",
      "PHARMACY_HOSPITAL_INVENTORY_MAPPING",
    ],
  },
  {
    id: "catalog",
    path: "/pharmacy/admin/enterprise",
    label: "Catalog",
    match: (p) =>
      p.startsWith("/pharmacy/admin/enterprise") &&
      !p.includes("/import") &&
      !p.includes("/duplicates") &&
      !p.includes("/ai-review"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES"],
  },
  {
    id: "import",
    path: "/pharmacy/admin/enterprise/import",
    label: "Import",
    match: (p) => p.includes("/pharmacy/admin/enterprise/import"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES"],
  },
  {
    id: "duplicates",
    path: "/pharmacy/admin/enterprise/duplicates",
    label: "Duplicates",
    match: (p) => p.includes("/pharmacy/admin/enterprise/duplicates"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES"],
  },
  {
    id: "hospital-mapping",
    path: "/pharmacy/admin/hospital-mapping",
    label: "Hospital mapping",
    match: (p) => p.includes("/pharmacy/admin/hospital-mapping"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES", "PHARMACY_HOSPITAL_INVENTORY_MAPPING"],
  },
  {
    id: "categories",
    path: "/pharmacy/admin/categories",
    label: "Categories",
    match: (p) => p.includes("/pharmacy/admin/categories"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES", "PHARMACY_HOSPITAL_INVENTORY_MAPPING"],
  },
  {
    id: "hospital-pricing",
    path: "/pharmacy/admin/hospital-pricing",
    label: "Hospital pricing",
    match: (p) => p.includes("/pharmacy/admin/hospital-pricing"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES", "PHARMACY_HOSPITAL_INVENTORY_MAPPING"],
  },
  {
    id: "configuration",
    path: "/setup/pharmacy/configuration/generics",
    label: "Configuration",
    match: (p) => p.startsWith("/setup/pharmacy/configuration"),
    moduleIds: ["PHARMACY_SETUP_GENERICS"],
  },
  {
    id: "ai-review",
    path: "/pharmacy/admin/enterprise/ai-review",
    label: "AI review",
    match: (p) => p.includes("/pharmacy/admin/enterprise/ai-review"),
    moduleIds: ["PHARMACY_ENTERPRISE_MEDICINES"],
  },
];

export function tabVisible(tab, canAccessModule) {
  if (typeof canAccessModule !== "function") return true;
  if (Array.isArray(tab.anyModuleIds) && tab.anyModuleIds.length) {
    return tab.anyModuleIds.some((id) => canAccessModule(id));
  }
  if (Array.isArray(tab.moduleIds) && tab.moduleIds.length) {
    return tab.moduleIds.some((id) => canAccessModule(id));
  }
  return true;
}

export function resolveActiveTabPath(pathname, tabs = PHARMACY_SETUP_TABS) {
  const hit = tabs.find((t) => t.match(pathname));
  return hit?.path ?? "/pharmacy/admin/setup";
}
